import { download, checka, checkb } from "assets/icons";
import {
  AppButton,
  AppModal,
  //eslint-disable-next-line
  FilterInputs,
  FormInput,
  FormSelect,
  SearchInput,
  Skeleton,
} from "components";
import { ApiService } from "services";
import DashboardLayout from "layouts/DashboardLayout";
import React, { useEffect, useState } from "react";
import { toast } from "react-hot-toast";
import styled from "styled-components";
import moment from "moment";
import { kFormatter2, kFormatter3 } from "utils/format";
import { userData } from "utils/userData";
import InstitutionTransactions from "components/InstitutionTransactions";
import Skeleton2 from "components/Skeleton2";

export default function Transactions() {
  const [transactions, setTransactions] = useState();
  const [transactionDetail, setTransactionDetail] = useState();
  const [transactModal, setTransactModal] = useState(false);
  const [checkedAmount, setCheckedAmount] = useState(false);
  const [checkedRequestTime, setCheckedRequestTime] = useState(false);
  const [checkedResponseTime, setCheckedResponseTime] = useState(false);
  const [checkedRequeryCount, setCheckedRequeryCount] = useState(false);
  const [checkedStatusCode, setCheckedStatusCode] = useState(false);
  const [checkedRequestType, setCheckedRequestType] = useState(false);
  const [checkedRoute, setCheckedRoute] = useState(false);
  const [checkedSourceBank, setCheckedSourceBank] = useState(false);
  const [checkedDestBank, setCheckedDestBank] = useState(false);
  const [filter, setFilter] = useState(false);

  const [amountFrom, setAmountFrom] = useState(false);
  const [amountTo, setAmountTo] = useState(false);

  const [requestTimeFrom, setRequestTimeFrom] = useState(false);
  const [requestTimeTo, setRequestTimeTo] = useState(false);

  const [responseFrom, setResponseFrom] = useState(false);
  const [responseTo, setResponseTo] = useState(false);

  const [requeryCountFrom, setRequeryCountFrom] = useState(false);
  const [requeryCountTo, setRequeryCountTo] = useState(false);

  const [statusCode, setStatusCode] = useState(false);
  const [requestType, setRequestType] = useState(false);
  const [route, setRoute] = useState(false);
  const [sourceBank, setSourceBank] = useState(false);
  const [destBank, setDestBank] = useState(false);

  const [loading, setLoading] = useState(false);
  const [loading2, setLoading2] = useState(false);

  const getTransactions = async (param) => {
    setLoading(true);
    try {
      const data = await ApiService.getTransaction(param);
      console.log(data);
      setTransactions(data?.data);
      setLoading(false);
      setFilter(false);
    } catch (err) {
      console.log(err);
      if (err?.message === "It's not you, it's us. Try again later.") {
      } else if (err?.message === "Network Error") {
        return;
      } else {
        toast.error(err?.response?.data?.message || err?.message);
      }
      setLoading(false);
    }
  };

  const getTransactions2 = async (param) => {
    setLoading2(true);
    try {
      const data = await ApiService.getTransaction(param);
      console.log(data?.data?.downloadLink);
      if (data?.data?.downloadLink) {
        window.open(data?.data?.downloadLink, "_blank");
      }
      toast.success(data?.message);
      setLoading2(false);
    } catch (err) {
      console.log(err);
      if (err?.message === "It's not you, it's us. Try again later.") {
      } else if (err?.message === "Network Error") {
        return;
      } else {
        toast.error(err?.response?.data?.message || err?.message);
      }
      setLoading2(false);
    }
  };

  const [currentPage, setCurrentPage] = useState(1);
  let currentPageNo = currentPage;
  console.log(currentPageNo);
  const [start, setStart] = useState(1);
  //eslint-disable-next-line
  const [end, setEnd] = useState(50);

  const [searchInput, setSearchInput] = useState("");

  useEffect(() => {
    getTransactions();
  }, []);

  return (
    <>
      {loading2 && <Skeleton />}
      {userData?.userDetail?.role === "chiefAdmin" && (
        <>
          <DashboardLayout>
            <Table>
              <TableHead>
                <div className="table_head">
                  <div>
                    <div className="title_b">Current Month Transactions</div>
                  </div>
                  <div className="table_head_inner">
                    <SearchInput
                      onChange={(e) => {
                        getTransactions(`?search=${e.target.value || ""}`);
                        setSearchInput(e.target.value);
                      }}
                      placeholder="Separate multiple search with a comma"
                    />

                    <FilterO
                      onClick={() => {
                        setFilter(!filter);
                        setCheckedAmount(false);
                        setCheckedRequeryCount(false);
                        setCheckedRequestTime(false);
                        setCheckedRequestType(false);
                        setCheckedResponseTime(false);
                        setCheckedRoute(false);
                        setCheckedStatusCode(false);
                        setCheckedDestBank(false);
                        setCheckedSourceBank(false);

                        setDestBank("");
                        setSourceBank("");

                        setAmountFrom("");
                        setAmountTo("");

                        setRequeryCountFrom("");
                        setRequeryCountTo("");

                        setRequestTimeFrom("");
                        setRequestTimeTo("");

                        setRequeryCountFrom("");
                        setRequeryCountTo("");

                        setStatusCode("");
                        setRoute("");
                        setRequestType("");
                      }}
                    >
                      <div className="title">Filters By</div>
                      <div
                        style={{
                          padding: "20px",
                        }}
                      >
                        <svg
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            width: "100%",
                          }}
                          width="12"
                          height="8"
                          viewBox="0 0 12 8"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M0.495471 2.68089L4.82387 6.74143C5.47563 7.35286 6.52849 7.35286 7.18025 6.74143L11.5086 2.68089C12.5615 1.6932 11.8095 0 10.3221 0H1.66531C0.177944 0 -0.557382 1.6932 0.495471 2.68089Z"
                            fill="#212121"
                          />
                        </svg>
                      </div>
                    </FilterO>
                    {userData?.userDetail?.role === "nonBankUser2" && (
                      <Button
                        onClick={() => {
                          if (
                            (amountFrom && amountTo) ||
                            (requestTimeFrom && requestTimeTo) ||
                            (responseFrom && responseTo) ||
                            (requeryCountFrom && requeryCountTo) ||
                            statusCode ||
                            requestType ||
                            route ||
                            sourceBank ||
                            destBank ||
                            searchInput
                          ) {
                            getTransactions2(
                              `?page=${currentPageNo}${
                                searchInput ? `&search=${searchInput}` : ""
                              }${
                                checkedAmount
                                  ? `&amountFrom=${amountFrom}&amountTo=${amountTo}`
                                  : ""
                              }${
                                checkedRequestTime
                                  ? `&requestDateFrom=${requestTimeFrom}&requestDateTo=${requestTimeTo}`
                                  : ""
                              }${
                                checkedResponseTime
                                  ? `&responseDateFrom=${responseFrom}&responseDateTo=${responseTo}`
                                  : ""
                              }${
                                checkedRequeryCount
                                  ? `&requeryCountFrom=${requeryCountFrom}&requeryCountTo=${requeryCountTo}`
                                  : ""
                              }${
                                checkedStatusCode ? `&status=${statusCode}` : ""
                              }${
                                checkedRequestType
                                  ? `&status=${requestType}`
                                  : ""
                              }${checkedRoute ? `&status=${route}` : ""}${
                                checkedSourceBank
                                  ? `&sourceBank=${sourceBank}`
                                  : ""
                              }${
                                checkedDestBank ? `&destBank=${destBank}` : ""
                              }&download=true`
                            );
                          } else {
                            toast.error("A search or filter must be done");
                          }
                        }}
                        style={{ width: "310px" }}
                      >
                        <img src={download} alt="" />
                        <span>Download CSV</span>
                        <svg
                          style={{ marginLeft: "10px" }}
                          width="11"
                          height="6"
                          viewBox="0 0 11 6"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M0.912893 2.23408L4.51989 5.61786C5.06303 6.12738 5.94041 6.12738 6.48354 5.61786L10.0905 2.23408C10.9679 1.411 10.3412 0 9.10175 0H1.88776C0.648287 0 0.0355151 1.411 0.912893 2.23408Z"
                            fill="white"
                          />
                        </svg>
                      </Button>
                    )}

                    {userData?.userDetail?.role === "chiefAdmin" && (
                      <Button
                        onClick={() => {
                          if (
                            (amountFrom && amountTo) ||
                            (requestTimeFrom && requestTimeTo) ||
                            (responseFrom && responseTo) ||
                            (requeryCountFrom && requeryCountTo) ||
                            statusCode ||
                            requestType ||
                            route ||
                            sourceBank ||
                            destBank ||
                            searchInput
                          ) {
                            getTransactions2(
                              `?page=${currentPageNo}${
                                searchInput ? `&search=${searchInput}` : ""
                              }${
                                checkedAmount
                                  ? `&amountFrom=${amountFrom}&amountTo=${amountTo}`
                                  : ""
                              }${
                                checkedRequestTime
                                  ? `&requestDateFrom=${requestTimeFrom}&requestDateTo=${requestTimeTo}`
                                  : ""
                              }${
                                checkedResponseTime
                                  ? `&responseDateFrom=${responseFrom}&responseDateTo=${responseTo}`
                                  : ""
                              }${
                                checkedRequeryCount
                                  ? `&requeryCountFrom=${requeryCountFrom}&requeryCountTo=${requeryCountTo}`
                                  : ""
                              }${
                                checkedStatusCode ? `&status=${statusCode}` : ""
                              }${
                                checkedRequestType
                                  ? `&status=${requestType}`
                                  : ""
                              }${checkedRoute ? `&status=${route}` : ""}${
                                checkedSourceBank
                                  ? `&sourceBank=${sourceBank}`
                                  : ""
                              }${
                                checkedDestBank ? `&destBank=${destBank}` : ""
                              }&download=true`
                            );
                          } else {
                            toast.error("A search or filter must be done");
                          }
                        }}
                        style={{ width: "310px" }}
                      >
                        <img src={download} alt="" />
                        <span>Download CSV</span>
                        <svg
                          style={{ marginLeft: "10px" }}
                          width="11"
                          height="6"
                          viewBox="0 0 11 6"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M0.912893 2.23408L4.51989 5.61786C5.06303 6.12738 5.94041 6.12738 6.48354 5.61786L10.0905 2.23408C10.9679 1.411 10.3412 0 9.10175 0H1.88776C0.648287 0 0.0355151 1.411 0.912893 2.23408Z"
                            fill="white"
                          />
                        </svg>
                      </Button>
                    )}
                  </div>
                </div>
              </TableHead>
              <TableBody>
                <TableBodyContent className="table_body_head grid_attribute">
                  <div style={{ width: "100px", marginRight: "10px" }}>
                    Institution
                  </div>
                  <div style={{ width: "250px", marginRight: "10px" }}>
                    Txid
                  </div>
                  <div style={{ width: "100px", marginRight: "10px" }}>
                    Source bank
                  </div>
                  <div style={{ width: "100px", marginRight: "10px" }}>
                    Dest bank
                  </div>
                  <div style={{ width: "100px", marginRight: "10px" }}>
                    Account No.
                  </div>
                  <div style={{ width: "120px", marginRight: "10px" }}>
                    Amount
                  </div>
                  <div
                    style={{
                      width: "250px",
                      marginRight: "10px",
                    }}
                  >
                    Remark
                  </div>
                  <div style={{ width: "250px", marginRight: "10px" }}>
                    status message
                  </div>
                  <div style={{ width: "100px", marginRight: "10px" }}>
                    status code
                  </div>
                  <div style={{ width: "250px", marginRight: "10px" }}>
                    beneficiary
                  </div>
                  <div style={{ width: "110px", marginRight: "10px" }}>
                    sender
                  </div>
                  <div style={{ width: "100px", marginRight: "10px" }}>
                    debit account
                  </div>
                  <div style={{ width: "60px", marginRight: "10px" }}>
                    approved
                  </div>
                  <div style={{ width: "100px", marginRight: "10px" }}>
                    request type
                  </div>
                  <div style={{ width: "120px", marginRight: "10px" }}>
                    reference
                  </div>
                  <div style={{ width: "100px", marginRight: "10px" }}>
                    client
                  </div>
                  <div style={{ width: "100px", marginRight: "10px" }}>
                    request id
                  </div>
                  <div style={{ width: "160px", marginRight: "10px" }}>
                    request time
                  </div>
                  <div style={{ width: "80px", marginRight: "10px" }}>
                    route
                  </div>
                  <div style={{ width: "80px", marginRight: "10px" }}>
                    route bin
                  </div>
                  <div style={{ width: "160px", marginRight: "10px" }}>
                    response time
                  </div>
                  <div style={{ width: "80px", marginRight: "10px" }}>
                    response id
                  </div>

                  <div style={{ width: "180px", marginRight: "10px" }}>rrn</div>
                  <div style={{ width: "100px", marginRight: "10px" }}>
                    requery count
                  </div>
                  <div style={{ width: "80px", marginRight: "10px" }}>
                    reversible
                  </div>
                  <div style={{ width: "100px", marginRight: "10px" }}>
                    batch id
                  </div>
                  <div style={{ width: "100px", marginRight: "10px" }}>
                    direction
                  </div>
                </TableBodyContent>

                <div>
                  {" "}
                  <TableBodyContent>
                    {loading ? (
                      <div style={{ width: "80vw" }}>
                        <Skeleton2 height="500px" />
                      </div>
                    ) : (
                      transactions?.results?.map((item) => {
                        return (
                          <div
                            onClick={() => {
                              setTransactModal(true);
                              setTransactionDetail(item);
                            }}
                            className="table_body_item grid_attribute"
                          >
                            <div
                              style={{
                                wordBreak: "break-word",
                                marginRight: "10px",
                                width: "100px",
                              }}
                            >
                              {item?.institution || "-"}
                            </div>
                            <div
                              style={{
                                wordBreak: "break-word",
                                marginRight: "10px",
                                width: "250px",
                              }}
                            >
                              {item?.txid || "-"}
                            </div>
                            <div
                              style={{
                                wordBreak: "break-word",
                                marginRight: "10px",
                                width: "100px",
                              }}
                            >
                              {item?.sourcebank || "-"}
                            </div>
                            <div
                              style={{
                                wordBreak: "break-word",
                                marginRight: "10px",
                                width: "100px",
                              }}
                            >
                              {item?.destbank || "-"}
                            </div>
                            <div
                              style={{
                                wordBreak: "break-word",
                                marginRight: "10px",
                                width: "100px",
                              }}
                            >
                              {item?.accountno || "-"}
                            </div>
                            <div
                              style={{
                                wordBreak: "break-word",
                                marginRight: "10px",
                                width: "120px",
                              }}
                            >
                              {kFormatter3(item?.amount)}
                            </div>
                            <div
                              style={{
                                wordBreak: "break-word",
                                marginRight: "10px",
                                width: "250px",
                              }}
                            >
                              {item?.remark || "-"}
                            </div>
                            <div
                              style={{
                                wordBreak: "break-word",
                                marginRight: "10px",
                                width: "250px",
                              }}
                            >
                              {item?.statusmessage || "-"}
                            </div>
                            <div
                              style={{
                                wordBreak: "break-word",
                                marginRight: "10px",
                                width: "100px",
                              }}
                            >
                              {item?.statuscode || "-"}
                            </div>
                            <div
                              style={{
                                wordBreak: "break-word",
                                marginRight: "10px",
                                width: "250px",
                              }}
                            >
                              {item?.beneficiary
                                ? `${item?.beneficiary}`
                                : "N/A"}
                            </div>
                            <div
                              style={{
                                wordBreak: "break-word",
                                marginRight: "10px",
                                width: "110px",
                              }}
                            >
                              {item?.sender || "-"}
                            </div>
                            <div
                              style={{
                                wordBreak: "break-word",
                                marginRight: "10px",
                                width: "100px",
                              }}
                            >
                              {item?.debitaccount || "N/A"}
                            </div>
                            <div
                              style={{
                                wordBreak: "break-word",
                                marginRight: "10px",
                                width: "60px",
                              }}
                            >
                              {(item?.approved && "True") || "-"}
                            </div>
                            <div
                              style={{
                                wordBreak: "break-word",
                                marginRight: "10px",
                                width: "100px",
                              }}
                            >
                              {item?.requesttype || "-"}
                            </div>
                            <div
                              style={{
                                wordBreak: "break-word",
                                marginRight: "10px",
                                width: "120px",
                              }}
                            >
                              {item?.reference || "N/A"}
                            </div>
                            <div
                              style={{
                                wordBreak: "break-word",
                                marginRight: "10px",
                                width: "100px",
                              }}
                            >
                              {item?.client || "-"}
                            </div>
                            <div
                              style={{
                                wordBreak: "break-word",
                                marginRight: "10px",
                                width: "100px",
                              }}
                            >
                              {item?.requestid || "-"}
                            </div>
                            <div
                              style={{
                                wordBreak: "break-word",
                                marginRight: "10px",
                                width: "160px",
                              }}
                            >
                              {moment(item?.requesttime)
                                .subtract(1, "hours")
                                .format("DD-MM-YYYY hh:mm")}
                            </div>
                            <div
                              style={{
                                wordBreak: "break-word",
                                marginRight: "10px",
                                width: "80px",
                              }}
                            >
                              {item?.route || "-"}
                            </div>
                            <div
                              style={{
                                wordBreak: "break-word",
                                marginRight: "10px",
                                width: "80px",
                              }}
                            >
                              {item?.routebin || "N/A"}
                            </div>
                            <div
                              style={{
                                wordBreak: "break-word",
                                marginRight: "10px",
                                width: "160px",
                              }}
                            >
                              {moment(item?.responsetime)
                                .subtract(1, "hours")
                                .format("DD-MM-YYYY hh:mm")}
                            </div>
                            <div
                              style={{
                                wordBreak: "break-word",
                                marginRight: "10px",
                                width: "80px",
                              }}
                            >
                              {item?.responseid || "N/A"}
                            </div>

                            <div
                              style={{
                                wordBreak: "break-word",
                                marginRight: "10px",
                                width: "180px",
                              }}
                            >
                              {item?.rrn || "N/A"}
                            </div>
                            <div
                              style={{
                                wordBreak: "break-word",
                                marginRight: "10px",
                                width: "100px",
                              }}
                            >
                              {item?.requerycount || "-"}
                            </div>
                            <div
                              style={{
                                wordBreak: "break-word",
                                marginRight: "10px",
                                width: "80px",
                              }}
                            >
                              {item?.reversible || "-"}
                            </div>
                            <div
                              style={{
                                wordBreak: "break-word",
                                marginRight: "10px",
                                width: "100px",
                              }}
                            >
                              {item?.batchid || "N/A"}
                            </div>
                            <div
                              style={{
                                wordBreak: "break-word",
                                marginRight: "10px",
                                width: "100px",
                              }}
                            >
                              {item?.direction || "-"}
                            </div>
                          </div>
                        );
                      })
                    )}
                    <div
                      style={{
                        color: "#000000",
                        marginBottom: "40px",
                        fontSize: "16px",
                        textAlign: "center",
                        width: "100%",
                      }}
                    >
                      {transactions?.results?.length === 0 &&
                        "No Response Data Found"}
                    </div>
                  </TableBodyContent>
                </div>
              </TableBody>

              <TablePagination>
                <div>
                  Showing {start} -{" "}
                  {transactions?.results?.length >= 50
                    ? end
                    : transactions?.results?.length + start - 1}{" "}
                  entries of {kFormatter2(transactions?.count)}
                </div>

                <div className="buttons">
                  <button
                    onClick={() => {
                      if (!transactions?.previous) {
                        console.log("end");
                      } else {
                        const prev = async () => {
                          try {
                            const data = await getTransactions(
                              `?page=${currentPageNo - 1}${
                                searchInput ? `&search=${searchInput}` : ""
                              }${
                                checkedAmount
                                  ? `&amountFrom=${amountFrom}&amountTo=${amountTo}`
                                  : ""
                              }${
                                checkedRequestTime
                                  ? `&requestDateFrom=${requestTimeFrom}&requestDateTo=${requestTimeTo}`
                                  : ""
                              }${
                                checkedResponseTime
                                  ? `&responseDateFrom=${responseFrom}&responseDateTo=${responseTo}`
                                  : ""
                              }${
                                checkedRequeryCount
                                  ? `&requeryCountFrom=${requeryCountFrom}&requeryCountTo=${requeryCountTo}`
                                  : ""
                              }${
                                checkedStatusCode ? `&status=${statusCode}` : ""
                              }${
                                checkedRequestType
                                  ? `&status=${requestType}`
                                  : ""
                              }${
                                checkedSourceBank
                                  ? `&sourceBank=${sourceBank}`
                                  : ""
                              }${
                                checkedDestBank ? `&destBank=${destBank}` : ""
                              }${checkedRoute ? `&status=${route}` : ""}`
                            );
                            setCurrentPage((current) => current - 1);
                            setStart((current) => current - 50);
                            setEnd((current) => current - 50);
                            console.log(data);
                          } catch (e) {
                            console.log(e);
                          }
                        };

                        prev();
                      }
                    }}
                    style={{
                      backgroundColor: !transactions?.previous
                        ? "#fff"
                        : "#F5F5F5",
                      border: "1px solid #E0E0E0",
                      borderRadius: "6px",
                      color: !transactions?.previous ? "#CCCCCC" : "#000",
                      cursor: !transactions?.previous ? "default" : "pointer",
                      padding: "10px",
                      display: "flex",
                      alignItems: "center",
                      fontSize: "16px",
                    }}
                  >
                    <svg
                      style={{
                        transform: "rotate(180deg)",
                        marginRight: "10px",
                      }}
                      width="24"
                      height="25"
                      viewBox="0 0 24 25"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M19.75 12.7744L4.75 12.7744"
                        stroke={!transactions?.previous ? "#CCCCCC" : "#212121"}
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M13.7002 18.799L19.7502 12.775L13.7002 6.75"
                        stroke={!transactions?.previous ? "#CCCCCC" : "#212121"}
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                    Prev
                  </button>
                  &nbsp; &nbsp; &nbsp;
                  <button
                    onClick={() => {
                      if (!transactions?.next) {
                        console.log("end");
                      } else {
                        const next = async () => {
                          try {
                            const data = await getTransactions(
                              `?page=${currentPageNo + 1}${
                                searchInput ? `&search=${searchInput}` : ""
                              }${
                                checkedAmount
                                  ? `&amountFrom=${amountFrom}&amountTo=${amountTo}`
                                  : ""
                              }${
                                checkedRequestTime
                                  ? `&requestDateFrom=${requestTimeFrom}&requestDateTo=${requestTimeTo}`
                                  : ""
                              }${
                                checkedResponseTime
                                  ? `&responseDateFrom=${responseFrom}&responseDateTo=${responseTo}`
                                  : ""
                              }${
                                checkedRequeryCount
                                  ? `&requeryCountFrom=${requeryCountFrom}&requeryCountTo=${requeryCountTo}`
                                  : ""
                              }${
                                checkedStatusCode ? `&status=${statusCode}` : ""
                              }${
                                checkedRequestType
                                  ? `&status=${requestType}`
                                  : ""
                              }${
                                checkedSourceBank
                                  ? `&sourceBank=${sourceBank}`
                                  : ""
                              }${
                                checkedDestBank ? `&destBank=${destBank}` : ""
                              }${checkedRoute ? `&status=${route}` : ""}`
                            );
                            setCurrentPage((current) => current + 1);
                            setStart((current) => current + 50);
                            setEnd((current) => current + 50);
                            console.log(data);
                          } catch (e) {
                            console.log(e);
                          }
                        };

                        next();
                      }
                    }}
                    style={{
                      backgroundColor: !transactions?.next ? "#fff" : "#F5F5F5",
                      border: "1px solid #E0E0E0",
                      borderRadius: "6px",
                      color: !transactions?.next ? "#CCCCCC" : "#000",
                      cursor: !transactions?.next ? "default" : "pointer",
                      padding: "10px",
                      display: "flex",
                      alignItems: "center",
                      fontSize: "16px",
                    }}
                  >
                    Next
                    <svg
                      style={{
                        marginLeft: "10px",
                      }}
                      width="24"
                      height="25"
                      viewBox="0 0 24 25"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M19.75 12.7744L4.75 12.7744"
                        stroke={!transactions?.next ? "#CCCCCC" : "#212121"}
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M13.7002 18.799L19.7502 12.775L13.7002 6.75"
                        stroke={!transactions?.next ? "#CCCCCC" : "#212121"}
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </button>
                </div>
              </TablePagination>
            </Table>
            {transactModal && (
              <AppModal
                closeModal={() => {
                  setTransactModal(false);
                }}
                maxWidth="1500px"
              >
                <div
                  style={{
                    display: "grid",
                    gap: "20px",
                    gridTemplateColumns: "1fr 1fr 1fr",
                  }}
                >
                  <div style={{ width: "100%" }}>
                    <FormInput
                      defaultValue={transactionDetail?.institution}
                      label="Institution"
                      padding="11px 6px"
                      labelColor="#14A2FD"
                      bottom="0px"
                      disabled={true}
                    />
                  </div>
                  <div style={{ width: "100%" }}>
                    <FormInput
                      defaultValue={transactionDetail?.txid}
                      padding="11px 6px"
                      bottom="0px"
                      labelColor="#14A2FD"
                      label="TXID"
                      disabled={true}
                    />
                  </div>
                  <div style={{ width: "100%" }}>
                    <FormInput
                      defaultValue={transactionDetail?.route}
                      padding="11px 6px"
                      labelColor="#14A2FD"
                      bottom="0px"
                      label="Route"
                      disabled={true}
                    />
                  </div>
                  <div style={{ width: "100%" }}>
                    <FormInput
                      defaultValue={transactionDetail?.sourcebank}
                      labelColor="#14A2FD"
                      padding="11px 6px"
                      bottom="0px"
                      label="Source Bank"
                      disabled={true}
                    />
                  </div>
                  <div style={{ width: "100%" }}>
                    <FormInput
                      defaultValue={transactionDetail?.destbank}
                      padding="11px 6px"
                      bottom="0px"
                      labelColor="#14A2FD"
                      label="Destination Bank"
                      disabled={true}
                    />
                  </div>
                  <div style={{ width: "100%" }}>
                    <FormInput
                      defaultValue={transactionDetail?.routebin}
                      labelColor="#14A2FD"
                      padding="11px 6px"
                      bottom="0px"
                      label="Route Bin"
                      disabled={true}
                    />
                  </div>
                  <div style={{ width: "100%" }}>
                    <FormInput
                      defaultValue={transactionDetail?.accountno}
                      padding="11px 6px"
                      labelColor="#14A2FD"
                      bottom="0px"
                      label="Account Number"
                      disabled={true}
                    />
                  </div>
                  <div style={{ width: "100%" }}>
                    <FormInput
                      defaultValue={transactionDetail?.amount}
                      labelColor="#14A2FD"
                      padding="11px 6px"
                      bottom="0px"
                      label="Amount"
                      disabled={true}
                    />
                  </div>
                  <div style={{ width: "100%" }}>
                    <FormInput
                      defaultValue={transactionDetail?.responsetime}
                      padding="11px 6px"
                      label="Response Time"
                      labelColor="#14A2FD"
                      bottom="0px"
                      disabled={true}
                    />
                  </div>

                  <div style={{ width: "100%" }}>
                    <FormInput
                      defaultValue={transactionDetail?.remark}
                      labelColor="#14A2FD"
                      padding="11px 6px"
                      bottom="0px"
                      label="Remark"
                      disabled={true}
                    />
                  </div>
                  <div style={{ width: "100%" }}>
                    <FormInput
                      defaultValue={transactionDetail?.responseid}
                      padding="11px 6px"
                      labelColor="#14A2FD"
                      label="Response ID"
                      bottom="0px"
                      disabled={true}
                    />
                  </div>
                  <div style={{ width: "100%" }}>
                    <FormInput
                      defaultValue={transactionDetail?.statusmessage}
                      labelColor="#14A2FD"
                      padding="11px 6px"
                      bottom="0px"
                      label="Status Message"
                      disabled={true}
                    />
                  </div>
                  <div style={{ width: "100%" }}>
                    <FormInput
                      defaultValue={transactionDetail?.statuscode}
                      padding="11px 6px"
                      label="Status Code"
                      labelColor="#14A2FD"
                      bottom="0px"
                      disabled={true}
                    />
                  </div>

                  <div style={{ width: "100%" }}>
                    <FormInput
                      defaultValue={transactionDetail?.beneficiary}
                      padding="11px 6px"
                      labelColor="#14A2FD"
                      label="Beneficiary"
                      bottom="0px"
                      disabled={true}
                    />
                  </div>
                  <div style={{ width: "100%" }}>
                    <FormInput
                      defaultValue={transactionDetail?.sender}
                      padding="11px 6px"
                      labelColor="#14A2FD"
                      bottom="0px"
                      label="Sender"
                      disabled={true}
                    />
                  </div>
                  <div style={{ width: "100%" }}>
                    <FormInput
                      defaultValue={transactionDetail?.rrn}
                      padding="11px 6px"
                      label="RRN"
                      labelColor="#14A2FD"
                      bottom="0px"
                      disabled={true}
                    />
                  </div>
                  <div style={{ width: "100%" }}>
                    <FormInput
                      defaultValue={transactionDetail?.debitaccount}
                      padding="11px 6px"
                      bottom="0px"
                      labelColor="#14A2FD"
                      label="Debit Account"
                      disabled={true}
                    />
                  </div>
                  <div style={{ width: "100%" }}>
                    <FormInput
                      defaultValue={transactionDetail?.approved}
                      padding="11px 6px"
                      labelColor="#14A2FD"
                      label="Approved"
                      bottom="0px"
                      disabled={true}
                    />
                  </div>
                  <div style={{ width: "100%" }}>
                    <FormInput
                      defaultValue={transactionDetail?.reversible}
                      padding="11px 6px"
                      bottom="0px"
                      labelColor="#14A2FD"
                      label="Reversible"
                      disabled={true}
                    />
                  </div>
                  <div style={{ width: "100%" }}>
                    <FormInput
                      defaultValue={transactionDetail?.requesttype}
                      padding="11px 6px"
                      labelColor="#14A2FD"
                      label="Request Type"
                      bottom="0px"
                      disabled={true}
                    />
                  </div>
                  <div style={{ width: "100%" }}>
                    <FormInput
                      defaultValue={transactionDetail?.client}
                      label="Client"
                      bottom="0px"
                      labelColor="#14A2FD"
                      padding="11px 6px"
                      disabled={true}
                    />
                  </div>
                  <div style={{ width: "100%" }}>
                    <FormInput
                      defaultValue={transactionDetail?.batchid}
                      padding="11px 6px"
                      bottom="0px"
                      labelColor="#14A2FD"
                      label="Batch ID"
                      disabled={true}
                    />
                  </div>
                  <div style={{ width: "100%" }}>
                    <FormInput
                      defaultValue={transactionDetail?.requestid}
                      bottom="0px"
                      labelColor="#14A2FD"
                      label="Request ID"
                      padding="11px 6px"
                      disabled={true}
                    />
                  </div>
                  <div style={{ width: "100%" }}>
                    <FormInput
                      defaultValue={transactionDetail?.requesttime}
                      padding="11px 6px"
                      bottom="0px"
                      labelColor="#14A2FD"
                      label="Request Time"
                      disabled={true}
                    />
                  </div>
                  <div style={{ width: "100%" }}>
                    <FormInput
                      defaultValue={transactionDetail?.direction}
                      label="Direction"
                      bottom="0px"
                      padding="11px 6px"
                      labelColor="#14A2FD"
                      disabled={true}
                    />
                  </div>
                </div>
              </AppModal>
            )}
            {filter && (
              <ViewAdminBody
                onClick={() => {
                  setFilter(false);
                  setCheckedAmount(false);
                  setCheckedRequeryCount(false);
                  setCheckedRequestTime(false);
                  setCheckedRequestType(false);
                  setCheckedResponseTime(false);
                  setCheckedRoute(false);
                  setCheckedStatusCode(false);

                  setAmountFrom("");
                  setAmountTo("");

                  setRequeryCountFrom("");
                  setRequeryCountTo("");

                  setRequestTimeFrom("");
                  setRequestTimeTo("");

                  setRequeryCountFrom("");
                  setRequeryCountTo("");

                  setStatusCode("");
                  setRoute("");
                  setRequestType("");
                }}
              >
                <ViewAdmin
                  onClick={(e) => {
                    e.stopPropagation();
                  }}
                >
                  <svg
                    onClick={() => {
                      setFilter(false);
                      setCheckedAmount(false);
                      setCheckedRequeryCount(false);
                      setCheckedRequestTime(false);
                      setCheckedRequestType(false);
                      setCheckedResponseTime(false);
                      setCheckedRoute(false);
                      setCheckedStatusCode(false);

                      setAmountFrom("");
                      setAmountTo("");

                      setRequeryCountFrom("");
                      setRequeryCountTo("");

                      setRequestTimeFrom("");
                      setRequestTimeTo("");

                      setRequeryCountFrom("");
                      setRequeryCountTo("");

                      setStatusCode("");
                      setRoute("");
                      setRequestType("");
                    }}
                    style={{
                      position: "absolute",
                      top: "20px",
                      right: "20px",
                      cursor: "pointer",
                    }}
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect width="24" height="24" rx="2.66667" fill="#F4F6FA" />
                    <path
                      d="M15.3337 8.6665L8.66699 15.3332M8.66699 8.6665L15.3337 15.3332"
                      stroke="#007BFF"
                      stroke-width="1.11111"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>

                  <div className="title" style={{ padding: "20px 0" }}>
                    Filter By
                  </div>
                  <div className="filter_body">
                    <div className="section">
                      <img
                        onClick={() => {
                          setCheckedAmount(!checkedAmount);
                        }}
                        src={checkedAmount ? checka : checkb}
                        alt=""
                        srcset=""
                      />
                      <div>
                        <FormInput
                          padding="13px 8px"
                          width="99.5%"
                          label="Amount"
                          type="number"
                          placeholder="From"
                          disabled={!checkedAmount}
                          onChange={(e) => {
                            setAmountFrom(e.target.value);
                          }}
                        />
                        <FormInput
                          padding="13px 8px"
                          width="99.5%"
                          type="number"
                          placeholder="To"
                          disabled={!checkedAmount}
                          onChange={(e) => {
                            setAmountTo(e.target.value);
                          }}
                        />
                      </div>
                    </div>
                    <div className="section">
                      <div>
                        <div className="top">
                          <img
                            onClick={() => {
                              setCheckedRequestTime(!checkedRequestTime);
                            }}
                            src={checkedRequestTime ? checka : checkb}
                            alt=""
                            srcset=""
                          />
                          <div>
                            <label>Request Time</label>
                          </div>
                        </div>

                        <div className="side">
                          <input
                            style={{
                              width: "92.8%",
                              padding: "14px",
                              marginBottom: "20px",
                              borderRadius: "6px",
                              border: "1px solid #5c5c5c",
                            }}
                            label="Request Time"
                            type="date"
                            disabled={!checkedRequestTime}
                            onChange={(e) => {
                              setRequestTimeFrom(e.target.value);
                            }}
                          />
                          <input
                            style={{
                              width: "92.8%",
                              padding: "14px",
                              borderRadius: "6px",
                              border: "1px solid #5c5c5c",
                            }}
                            label="Request Time"
                            type="date"
                            disabled={!checkedRequestTime}
                            onChange={(e) => {
                              setRequestTimeTo(e.target.value);
                            }}
                          />
                        </div>
                      </div>
                    </div>

                    <div className="section">
                      <div>
                        <div className="top">
                          <img
                            onClick={() => {
                              setCheckedResponseTime(!checkedResponseTime);
                            }}
                            src={checkedResponseTime ? checka : checkb}
                            alt=""
                            srcset=""
                          />
                          <div>
                            <label>Response Time</label>
                          </div>
                        </div>

                        <div className="side">
                          <input
                            style={{
                              width: "92.8%",
                              padding: "14px",
                              marginBottom: "20px",
                              borderRadius: "6px",
                              border: "1px solid #5c5c5c",
                            }}
                            label="Request Time"
                            disabled={!checkedResponseTime}
                            type="date"
                            onChange={(e) => {
                              setResponseFrom(e.target.value);
                            }}
                          />
                          <input
                            style={{
                              width: "92.8%",
                              padding: "14px",
                              borderRadius: "6px",
                              border: "1px solid #5c5c5c",
                            }}
                            label="Request Time"
                            disabled={!checkedResponseTime}
                            type="date"
                            onChange={(e) => {
                              setResponseTo(e.target.value);
                            }}
                          />
                        </div>
                      </div>
                    </div>

                    <div className="section">
                      <img
                        onClick={() => {
                          setCheckedRequeryCount(!checkedRequeryCount);
                        }}
                        src={checkedRequeryCount ? checka : checkb}
                        alt=""
                        srcset=""
                      />
                      <div>
                        <FormInput
                          label=" Requery Count"
                          type="number"
                          width="99.5%"
                          padding="13px 8px"
                          placeholder="From"
                          disabled={!checkedRequeryCount}
                          onChange={(e) => {
                            setRequeryCountFrom(e.target.value);
                          }}
                        />
                        <FormInput
                          width="99.5%"
                          type="number"
                          padding="13px 8px"
                          placeholder="To"
                          disabled={!checkedRequeryCount}
                          onChange={(e) => {
                            setRequeryCountTo(e.target.value);
                          }}
                        />
                      </div>
                    </div>
                    <div className="section">
                      <img
                        onClick={() => {
                          setCheckedStatusCode(!checkedStatusCode);
                        }}
                        src={checkedStatusCode ? checka : checkb}
                        alt=""
                        srcset=""
                      />
                      <div>
                        <FormSelect
                          padding="13px 8px"
                          width="99.5%"
                          placeholder="Status Code"
                          label="Status Code"
                          disabled={!checkedStatusCode}
                          onChange={(e) => {
                            setStatusCode(e.target.value);
                          }}
                          options={[
                            { value: "00", label: "00" },
                            { value: "03", label: "03" },
                            { value: "05", label: "05" },
                            { value: "null", label: "Null" },
                            { value: "blank", label: "Blank" },
                          ]}
                          optionLabel="label"
                          optionValue="value"
                        />
                      </div>
                    </div>
                    <div className="section">
                      <img
                        onClick={() => {
                          setCheckedRequestType(!checkedRequestType);
                        }}
                        src={checkedRequestType ? checka : checkb}
                        alt=""
                        srcset=""
                      />
                      <div>
                        <FormSelect
                          padding="13px 8px"
                          placeholder="Request Type"
                          width="99.5%"
                          label="Request Type"
                          disabled={!checkedRequestType}
                          options={[
                            { value: "debit", label: "Credit" },
                            { value: "credit", label: "Debit" },
                          ]}
                          optionLabel="label"
                          optionValue="value"
                          onChange={(e) => {
                            setRequestType(e.target.value);
                          }}
                        />
                      </div>
                    </div>
                    <div className="section">
                      <img
                        onClick={() => {
                          setCheckedRoute(!checkedRoute);
                        }}
                        src={checkedRoute ? checka : checkb}
                        alt=""
                        srcset=""
                      />
                      <div>
                        <FormSelect
                          padding="13px 8px"
                          placeholder="Route"
                          width="99.5%"
                          label="Route"
                          disabled={!checkedRoute}
                          options={[
                            { value: "direct", label: "Direct" },
                            { value: "nip", label: "NIP" },
                          ]}
                          onChange={(e) => {
                            setRoute(e.target.value);
                          }}
                        />
                      </div>
                    </div>

                    <div className="section">
                      <img
                        onClick={() => {
                          setCheckedSourceBank(!checkedSourceBank);
                        }}
                        src={checkedSourceBank ? checka : checkb}
                        alt=""
                        srcset=""
                      />
                      <div>
                        <FormInput
                          label=" Source Bank"
                          type="text"
                          width="99.5%"
                          padding="13px 8px"
                          placeholder="From"
                          disabled={!checkedSourceBank}
                          onChange={(e) => {
                            setSourceBank(e.target.value);
                          }}
                        />
                      </div>
                    </div>

                    <div className="section">
                      <img
                        onClick={() => {
                          setCheckedDestBank(!checkedDestBank);
                        }}
                        src={checkedDestBank ? checka : checkb}
                        alt=""
                        srcset=""
                      />
                      <div>
                        <FormInput
                          label=" Destination Bank"
                          type="text"
                          width="99.5%"
                          padding="13px 8px"
                          placeholder="From"
                          disabled={!checkedDestBank}
                          onChange={(e) => {
                            setDestBank(e.target.value);
                          }}
                        />
                      </div>
                    </div>
                  </div>

                  <div style={{ paddingBottom: "20px" }}>
                    <AppButton
                      onClick={() => {
                        if (
                          (amountFrom && amountTo) ||
                          (requestTimeFrom && requestTimeTo) ||
                          (responseFrom && responseTo) ||
                          (requeryCountFrom && requeryCountTo) ||
                          statusCode ||
                          requestType ||
                          route ||
                          sourceBank ||
                          destBank
                        ) {
                          getTransactions(
                            `?page=${currentPageNo}${
                              checkedAmount
                                ? `&amountFrom=${amountFrom}&amountTo=${amountTo}`
                                : ""
                            }${
                              checkedRequestTime
                                ? `&requestDateFrom=${requestTimeFrom}&requestDateTo=${requestTimeTo}`
                                : ""
                            }${
                              checkedResponseTime
                                ? `&responseDateFrom=${responseFrom}&responseDateTo=${responseTo}`
                                : ""
                            }${
                              checkedRequeryCount
                                ? `&requeryCountFrom=${requeryCountFrom}&requeryCountTo=${requeryCountTo}`
                                : ""
                            }${
                              checkedStatusCode ? `&status=${statusCode}` : ""
                            }${
                              checkedRequestType ? `&status=${requestType}` : ""
                            }${
                              checkedSourceBank
                                ? `&sourceBank=${sourceBank}`
                                : ""
                            }${checkedDestBank ? `&destBank=${destBank}` : ""}${
                              checkedRoute ? `&status=${route}` : ""
                            }`
                          );
                        } else {
                          toast.error("fill required field(s)");
                        }
                      }}
                      loading={loading}
                      placeholder="
                  Apply Filter(s)
                  "
                    ></AppButton>
                    &nbsp;
                    <AppButton
                      onClick={() => {
                        setFilter(false);
                        setCheckedAmount(false);
                        setCheckedRequeryCount(false);
                        setCheckedRequestTime(false);
                        setCheckedRequestType(false);
                        setCheckedResponseTime(false);
                        setCheckedRoute(false);
                        setCheckedStatusCode(false);

                        setAmountFrom("");
                        setAmountTo("");

                        setRequeryCountFrom("");
                        setRequeryCountTo("");

                        setRequestTimeFrom("");
                        setRequestTimeTo("");

                        setRequeryCountFrom("");
                        setRequeryCountTo("");

                        setStatusCode("");
                        setRoute("");
                        setRequestType("");
                      }}
                      placeholder="
                  Cancel"
                      outline
                    ></AppButton>
                  </div>
                </ViewAdmin>
              </ViewAdminBody>
            )}
          </DashboardLayout>
        </>
      )}

      {userData?.userDetail?.role === "subAdmin1" && (
        <>
          <DashboardLayout>
            <Table>
              <TableHead>
                <div className="table_head">
                  <div>
                    <div className="title_b">Transactions</div>
                  </div>
                  <div className="table_head_inner">
                    <SearchInput
                      onChange={(e) => {
                        getTransactions(`?search=${e.target.value || ""}`);
                        setSearchInput(e.target.value);
                      }}
                      placeholder="Separate multiple search with a comma"
                    />

                    <FilterO
                      onClick={() => {
                        setFilter(!filter);
                        setCheckedAmount(false);
                        setCheckedRequeryCount(false);
                        setCheckedRequestTime(false);
                        setCheckedRequestType(false);
                        setCheckedResponseTime(false);
                        setCheckedRoute(false);
                        setCheckedStatusCode(false);
                        setCheckedDestBank(false);
                        setCheckedSourceBank(false);

                        setDestBank("");
                        setSourceBank("");

                        setAmountFrom("");
                        setAmountTo("");

                        setRequeryCountFrom("");
                        setRequeryCountTo("");

                        setRequestTimeFrom("");
                        setRequestTimeTo("");

                        setRequeryCountFrom("");
                        setRequeryCountTo("");

                        setStatusCode("");
                        setRoute("");
                        setRequestType("");
                      }}
                    >
                      <div className="title">Filters By</div>
                      <div
                        style={{
                          padding: "20px",
                        }}
                      >
                        <svg
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            width: "100%",
                          }}
                          width="12"
                          height="8"
                          viewBox="0 0 12 8"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M0.495471 2.68089L4.82387 6.74143C5.47563 7.35286 6.52849 7.35286 7.18025 6.74143L11.5086 2.68089C12.5615 1.6932 11.8095 0 10.3221 0H1.66531C0.177944 0 -0.557382 1.6932 0.495471 2.68089Z"
                            fill="#212121"
                          />
                        </svg>
                      </div>
                    </FilterO>

                    {userData?.userDetail?.role === "subAdmin2" && (
                      <Button
                        onClick={() => {
                          if (
                            (amountFrom && amountTo) ||
                            (requestTimeFrom && requestTimeTo) ||
                            (responseFrom && responseTo) ||
                            (requeryCountFrom && requeryCountTo) ||
                            statusCode ||
                            requestType ||
                            route ||
                            sourceBank ||
                            destBank ||
                            searchInput
                          ) {
                            getTransactions2(
                              `?page=${currentPageNo}${
                                searchInput ? `&search=${searchInput}` : ""
                              }${
                                checkedAmount
                                  ? `&amountFrom=${amountFrom}&amountTo=${amountTo}`
                                  : ""
                              }${
                                checkedRequestTime
                                  ? `&requestDateFrom=${requestTimeFrom}&requestDateTo=${requestTimeTo}`
                                  : ""
                              }${
                                checkedResponseTime
                                  ? `&responseDateFrom=${responseFrom}&responseDateTo=${responseTo}`
                                  : ""
                              }${
                                checkedRequeryCount
                                  ? `&requeryCountFrom=${requeryCountFrom}&requeryCountTo=${requeryCountTo}`
                                  : ""
                              }${
                                checkedStatusCode ? `&status=${statusCode}` : ""
                              }${
                                checkedRequestType
                                  ? `&status=${requestType}`
                                  : ""
                              }${checkedRoute ? `&status=${route}` : ""}${
                                checkedSourceBank
                                  ? `&sourceBank=${sourceBank}`
                                  : ""
                              }${
                                checkedDestBank ? `&destBank=${destBank}` : ""
                              }&download=true`
                            );
                          } else {
                            toast.error("A search or filter must be done");
                          }
                        }}
                        style={{ width: "310px" }}
                      >
                        <img src={download} alt="" />
                        <span>Download CSV</span>
                        <svg
                          style={{ marginLeft: "10px" }}
                          width="11"
                          height="6"
                          viewBox="0 0 11 6"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M0.912893 2.23408L4.51989 5.61786C5.06303 6.12738 5.94041 6.12738 6.48354 5.61786L10.0905 2.23408C10.9679 1.411 10.3412 0 9.10175 0H1.88776C0.648287 0 0.0355151 1.411 0.912893 2.23408Z"
                            fill="white"
                          />
                        </svg>
                      </Button>
                    )}

                    {userData?.userDetail?.role === "bankUser2" && (
                      <Button
                        onClick={() => {
                          if (
                            (amountFrom && amountTo) ||
                            (requestTimeFrom && requestTimeTo) ||
                            (responseFrom && responseTo) ||
                            (requeryCountFrom && requeryCountTo) ||
                            statusCode ||
                            requestType ||
                            route ||
                            sourceBank ||
                            destBank ||
                            searchInput
                          ) {
                            getTransactions2(
                              `?page=${currentPageNo}${
                                searchInput ? `&search=${searchInput}` : ""
                              }${
                                checkedAmount
                                  ? `&amountFrom=${amountFrom}&amountTo=${amountTo}`
                                  : ""
                              }${
                                checkedRequestTime
                                  ? `&requestDateFrom=${requestTimeFrom}&requestDateTo=${requestTimeTo}`
                                  : ""
                              }${
                                checkedResponseTime
                                  ? `&responseDateFrom=${responseFrom}&responseDateTo=${responseTo}`
                                  : ""
                              }${
                                checkedRequeryCount
                                  ? `&requeryCountFrom=${requeryCountFrom}&requeryCountTo=${requeryCountTo}`
                                  : ""
                              }${
                                checkedStatusCode ? `&status=${statusCode}` : ""
                              }${
                                checkedRequestType
                                  ? `&status=${requestType}`
                                  : ""
                              }${checkedRoute ? `&status=${route}` : ""}${
                                checkedSourceBank
                                  ? `&sourceBank=${sourceBank}`
                                  : ""
                              }${
                                checkedDestBank ? `&destBank=${destBank}` : ""
                              }&download=true`
                            );
                          } else {
                            toast.error("A search or filter must be done");
                          }
                        }}
                        style={{ width: "310px" }}
                      >
                        <img src={download} alt="" />
                        <span>Download CSV</span>
                        <svg
                          style={{ marginLeft: "10px" }}
                          width="11"
                          height="6"
                          viewBox="0 0 11 6"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M0.912893 2.23408L4.51989 5.61786C5.06303 6.12738 5.94041 6.12738 6.48354 5.61786L10.0905 2.23408C10.9679 1.411 10.3412 0 9.10175 0H1.88776C0.648287 0 0.0355151 1.411 0.912893 2.23408Z"
                            fill="white"
                          />
                        </svg>
                      </Button>
                    )}
                    {userData?.userDetail?.role === "bankAdmin" && (
                      <Button
                        onClick={() => {
                          if (
                            (amountFrom && amountTo) ||
                            (requestTimeFrom && requestTimeTo) ||
                            (responseFrom && responseTo) ||
                            (requeryCountFrom && requeryCountTo) ||
                            statusCode ||
                            requestType ||
                            route ||
                            sourceBank ||
                            destBank ||
                            searchInput
                          ) {
                            getTransactions2(
                              `?page=${currentPageNo}${
                                searchInput ? `&search=${searchInput}` : ""
                              }${
                                checkedAmount
                                  ? `&amountFrom=${amountFrom}&amountTo=${amountTo}`
                                  : ""
                              }${
                                checkedRequestTime
                                  ? `&requestDateFrom=${requestTimeFrom}&requestDateTo=${requestTimeTo}`
                                  : ""
                              }${
                                checkedResponseTime
                                  ? `&responseDateFrom=${responseFrom}&responseDateTo=${responseTo}`
                                  : ""
                              }${
                                checkedRequeryCount
                                  ? `&requeryCountFrom=${requeryCountFrom}&requeryCountTo=${requeryCountTo}`
                                  : ""
                              }${
                                checkedStatusCode ? `&status=${statusCode}` : ""
                              }${
                                checkedRequestType
                                  ? `&status=${requestType}`
                                  : ""
                              }${checkedRoute ? `&status=${route}` : ""}${
                                checkedSourceBank
                                  ? `&sourceBank=${sourceBank}`
                                  : ""
                              }${
                                checkedDestBank ? `&destBank=${destBank}` : ""
                              }&download=true`
                            );
                          } else {
                            toast.error("A search or filter must be done");
                          }
                        }}
                        style={{ width: "310px" }}
                      >
                        <img src={download} alt="" />
                        <span>Download CSV</span>
                        <svg
                          style={{ marginLeft: "10px" }}
                          width="11"
                          height="6"
                          viewBox="0 0 11 6"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M0.912893 2.23408L4.51989 5.61786C5.06303 6.12738 5.94041 6.12738 6.48354 5.61786L10.0905 2.23408C10.9679 1.411 10.3412 0 9.10175 0H1.88776C0.648287 0 0.0355151 1.411 0.912893 2.23408Z"
                            fill="white"
                          />
                        </svg>
                      </Button>
                    )}
                    {userData?.userDetail?.role === "nonBankAdmin" && (
                      <Button
                        onClick={() => {
                          if (
                            (amountFrom && amountTo) ||
                            (requestTimeFrom && requestTimeTo) ||
                            (responseFrom && responseTo) ||
                            (requeryCountFrom && requeryCountTo) ||
                            statusCode ||
                            requestType ||
                            route ||
                            sourceBank ||
                            destBank ||
                            searchInput
                          ) {
                            getTransactions2(
                              `?page=${currentPageNo}${
                                searchInput ? `&search=${searchInput}` : ""
                              }${
                                checkedAmount
                                  ? `&amountFrom=${amountFrom}&amountTo=${amountTo}`
                                  : ""
                              }${
                                checkedRequestTime
                                  ? `&requestDateFrom=${requestTimeFrom}&requestDateTo=${requestTimeTo}`
                                  : ""
                              }${
                                checkedResponseTime
                                  ? `&responseDateFrom=${responseFrom}&responseDateTo=${responseTo}`
                                  : ""
                              }${
                                checkedRequeryCount
                                  ? `&requeryCountFrom=${requeryCountFrom}&requeryCountTo=${requeryCountTo}`
                                  : ""
                              }${
                                checkedStatusCode ? `&status=${statusCode}` : ""
                              }${
                                checkedRequestType
                                  ? `&status=${requestType}`
                                  : ""
                              }${checkedRoute ? `&status=${route}` : ""}${
                                checkedSourceBank
                                  ? `&sourceBank=${sourceBank}`
                                  : ""
                              }${
                                checkedDestBank ? `&destBank=${destBank}` : ""
                              }&download=true`
                            );
                          } else {
                            toast.error("A search or filter must be done");
                          }
                        }}
                        style={{ width: "310px" }}
                      >
                        <img src={download} alt="" />
                        <span>Download CSV</span>
                        <svg
                          style={{ marginLeft: "10px" }}
                          width="11"
                          height="6"
                          viewBox="0 0 11 6"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M0.912893 2.23408L4.51989 5.61786C5.06303 6.12738 5.94041 6.12738 6.48354 5.61786L10.0905 2.23408C10.9679 1.411 10.3412 0 9.10175 0H1.88776C0.648287 0 0.0355151 1.411 0.912893 2.23408Z"
                            fill="white"
                          />
                        </svg>
                      </Button>
                    )}
                  </div>
                </div>
              </TableHead>
              <TableBody>
                <TableBodyContent className="table_body_head grid_attribute">
                  <div style={{ width: "100px", marginRight: "10px" }}>
                    Institution
                  </div>
                  <div style={{ width: "250px", marginRight: "10px" }}>
                    Txid
                  </div>
                  <div style={{ width: "100px", marginRight: "10px" }}>
                    Source bank
                  </div>
                  <div style={{ width: "100px", marginRight: "10px" }}>
                    Dest bank
                  </div>
                  <div style={{ width: "100px", marginRight: "10px" }}>
                    Account No.
                  </div>
                  <div style={{ width: "120px", marginRight: "10px" }}>
                    Amount
                  </div>
                  <div
                    style={{
                      width: "250px",
                      marginRight: "10px",
                    }}
                  >
                    Remark
                  </div>
                  <div style={{ width: "250px", marginRight: "10px" }}>
                    status message
                  </div>
                  <div style={{ width: "100px", marginRight: "10px" }}>
                    status code
                  </div>
                  <div style={{ width: "250px", marginRight: "10px" }}>
                    beneficiary
                  </div>
                  <div style={{ width: "110px", marginRight: "10px" }}>
                    sender
                  </div>
                  <div style={{ width: "100px", marginRight: "10px" }}>
                    debit account
                  </div>
                  <div style={{ width: "60px", marginRight: "10px" }}>
                    approved
                  </div>
                  <div style={{ width: "100px", marginRight: "10px" }}>
                    request type
                  </div>
                  <div style={{ width: "120px", marginRight: "10px" }}>
                    reference
                  </div>
                  <div style={{ width: "100px", marginRight: "10px" }}>
                    client
                  </div>
                  <div style={{ width: "100px", marginRight: "10px" }}>
                    request id
                  </div>
                  <div style={{ width: "160px", marginRight: "10px" }}>
                    request time
                  </div>
                  <div style={{ width: "80px", marginRight: "10px" }}>
                    route
                  </div>
                  <div style={{ width: "80px", marginRight: "10px" }}>
                    route bin
                  </div>
                  <div style={{ width: "160px", marginRight: "10px" }}>
                    response time
                  </div>
                  <div style={{ width: "80px", marginRight: "10px" }}>
                    response id
                  </div>

                  <div style={{ width: "180px", marginRight: "10px" }}>rrn</div>
                  <div style={{ width: "100px", marginRight: "10px" }}>
                    requery count
                  </div>
                  <div style={{ width: "80px", marginRight: "10px" }}>
                    reversible
                  </div>
                  <div style={{ width: "100px", marginRight: "10px" }}>
                    batch id
                  </div>
                  <div style={{ width: "100px", marginRight: "10px" }}>
                    direction
                  </div>
                </TableBodyContent>

                <div>
                  {" "}
                  <TableBodyContent>
                    {loading ? (
                      <div style={{ width: "80vw" }}>
                        <Skeleton2 height="500px" />
                      </div>
                    ) : (
                      transactions?.results?.map((item) => {
                        return (
                          <div
                            onClick={() => {
                              setTransactModal(true);
                              setTransactionDetail(item);
                            }}
                            className="table_body_item grid_attribute"
                          >
                            <div
                              style={{
                                wordBreak: "break-word",
                                marginRight: "10px",
                                width: "100px",
                              }}
                            >
                              {item?.institution || "-"}
                            </div>
                            <div
                              style={{
                                wordBreak: "break-word",
                                marginRight: "10px",
                                width: "250px",
                              }}
                            >
                              {item?.txid || "-"}
                            </div>
                            <div
                              style={{
                                wordBreak: "break-word",
                                marginRight: "10px",
                                width: "100px",
                              }}
                            >
                              {item?.sourcebank || "-"}
                            </div>
                            <div
                              style={{
                                wordBreak: "break-word",
                                marginRight: "10px",
                                width: "100px",
                              }}
                            >
                              {item?.destbank || "-"}
                            </div>
                            <div
                              style={{
                                wordBreak: "break-word",
                                marginRight: "10px",
                                width: "100px",
                              }}
                            >
                              {item?.accountno || "-"}
                            </div>
                            <div
                              style={{
                                wordBreak: "break-word",
                                marginRight: "10px",
                                width: "120px",
                              }}
                            >
                              {kFormatter3(item?.amount)}
                            </div>
                            <div
                              style={{
                                wordBreak: "break-word",
                                marginRight: "10px",
                                width: "250px",
                              }}
                            >
                              {item?.remark || "-"}
                            </div>
                            <div
                              style={{
                                wordBreak: "break-word",
                                marginRight: "10px",
                                width: "250px",
                              }}
                            >
                              {item?.statusmessage || "-"}
                            </div>
                            <div
                              style={{
                                wordBreak: "break-word",
                                marginRight: "10px",
                                width: "100px",
                              }}
                            >
                              {item?.statuscode || "-"}
                            </div>
                            <div
                              style={{
                                wordBreak: "break-word",
                                marginRight: "10px",
                                width: "250px",
                              }}
                            >
                              {item?.beneficiary
                                ? `${item?.beneficiary}`
                                : "N/A"}
                            </div>
                            <div
                              style={{
                                wordBreak: "break-word",
                                marginRight: "10px",
                                width: "110px",
                              }}
                            >
                              {item?.sender || "-"}
                            </div>
                            <div
                              style={{
                                wordBreak: "break-word",
                                marginRight: "10px",
                                width: "100px",
                              }}
                            >
                              {item?.debitaccount || "N/A"}
                            </div>
                            <div
                              style={{
                                wordBreak: "break-word",
                                marginRight: "10px",
                                width: "60px",
                              }}
                            >
                              {(item?.approved && "True") || "-"}
                            </div>
                            <div
                              style={{
                                wordBreak: "break-word",
                                marginRight: "10px",
                                width: "100px",
                              }}
                            >
                              {item?.requesttype || "-"}
                            </div>
                            <div
                              style={{
                                wordBreak: "break-word",
                                marginRight: "10px",
                                width: "120px",
                              }}
                            >
                              {item?.reference || "N/A"}
                            </div>
                            <div
                              style={{
                                wordBreak: "break-word",
                                marginRight: "10px",
                                width: "100px",
                              }}
                            >
                              {item?.client || "-"}
                            </div>
                            <div
                              style={{
                                wordBreak: "break-word",
                                marginRight: "10px",
                                width: "100px",
                              }}
                            >
                              {item?.requestid || "-"}
                            </div>
                            <div
                              style={{
                                wordBreak: "break-word",
                                marginRight: "10px",
                                width: "160px",
                              }}
                            >
                              {moment(item?.requesttime)
                                .subtract(1, "hours")
                                .format("DD-MM-YYYY hh:mm")}
                            </div>
                            <div
                              style={{
                                wordBreak: "break-word",
                                marginRight: "10px",
                                width: "80px",
                              }}
                            >
                              {item?.route || "-"}
                            </div>
                            <div
                              style={{
                                wordBreak: "break-word",
                                marginRight: "10px",
                                width: "80px",
                              }}
                            >
                              {item?.routebin || "N/A"}
                            </div>
                            <div
                              style={{
                                wordBreak: "break-word",
                                marginRight: "10px",
                                width: "160px",
                              }}
                            >
                              {moment(item?.responsetime)
                                .subtract(1, "hours")
                                .format("DD-MM-YYYY hh:mm")}
                            </div>
                            <div
                              style={{
                                wordBreak: "break-word",
                                marginRight: "10px",
                                width: "80px",
                              }}
                            >
                              {item?.responseid || "N/A"}
                            </div>

                            <div
                              style={{
                                wordBreak: "break-word",
                                marginRight: "10px",
                                width: "180px",
                              }}
                            >
                              {item?.rrn || "N/A"}
                            </div>
                            <div
                              style={{
                                wordBreak: "break-word",
                                marginRight: "10px",
                                width: "100px",
                              }}
                            >
                              {item?.requerycount || "-"}
                            </div>
                            <div
                              style={{
                                wordBreak: "break-word",
                                marginRight: "10px",
                                width: "80px",
                              }}
                            >
                              {item?.reversible || "-"}
                            </div>
                            <div
                              style={{
                                wordBreak: "break-word",
                                marginRight: "10px",
                                width: "100px",
                              }}
                            >
                              {item?.batchid || "N/A"}
                            </div>
                            <div
                              style={{
                                wordBreak: "break-word",
                                marginRight: "10px",
                                width: "100px",
                              }}
                            >
                              {item?.direction || "-"}
                            </div>
                          </div>
                        );
                      })
                    )}
                    <div
                      style={{
                        color: "#000000",
                        marginBottom: "40px",
                        fontSize: "16px",
                        textAlign: "center",
                        width: "100%",
                      }}
                    >
                      {transactions?.results?.length === 0 &&
                        "No Response Data Found"}
                    </div>
                  </TableBodyContent>
                </div>
              </TableBody>

              <TablePagination>
                <div>
                  Showing {start} -{" "}
                  {transactions?.results?.length >= 50
                    ? end
                    : transactions?.results?.length + start - 1}{" "}
                  entries of {kFormatter2(transactions?.count)}
                </div>

                <div className="buttons">
                  <button
                    onClick={() => {
                      if (!transactions?.previous) {
                        console.log("end");
                      } else {
                        const prev = async () => {
                          try {
                            const data = await getTransactions(
                              `?page=${
                                currentPageNo - 1
                              }&search=${searchInput}${
                                checkedAmount
                                  ? `&amountFrom=${amountFrom}&amountTo=${amountTo}`
                                  : ""
                              }${
                                checkedRequestTime
                                  ? `&requestDateFrom=${requestTimeFrom}&requestDateTo=${requestTimeTo}`
                                  : ""
                              }${
                                checkedResponseTime
                                  ? `&responseDateFrom=${responseFrom}&responseDateTo=${responseTo}`
                                  : ""
                              }${
                                checkedRequeryCount
                                  ? `&requeryCountFrom=${requeryCountFrom}&requeryCountTo=${requeryCountTo}`
                                  : ""
                              }${
                                checkedStatusCode ? `&status=${statusCode}` : ""
                              }${
                                checkedRequestType
                                  ? `&status=${requestType}`
                                  : ""
                              }${
                                checkedSourceBank
                                  ? `&sourceBank=${sourceBank}`
                                  : ""
                              }${
                                checkedDestBank ? `&destBank=${destBank}` : ""
                              }${checkedRoute ? `&status=${route}` : ""}`
                            );
                            setCurrentPage((current) => current - 1);
                            setStart((current) => current - 50);
                            setEnd((current) => current - 50);
                            console.log(data);
                          } catch (e) {
                            console.log(e);
                          }
                        };

                        prev();
                      }
                    }}
                    style={{
                      backgroundColor: !transactions?.previous
                        ? "#fff"
                        : "#F5F5F5",
                      border: "1px solid #E0E0E0",
                      borderRadius: "6px",
                      color: !transactions?.previous ? "#CCCCCC" : "#000",
                      cursor: !transactions?.previous ? "default" : "pointer",
                      padding: "10px",
                      display: "flex",
                      alignItems: "center",
                      fontSize: "16px",
                    }}
                  >
                    <svg
                      style={{
                        transform: "rotate(180deg)",
                        marginRight: "10px",
                      }}
                      width="24"
                      height="25"
                      viewBox="0 0 24 25"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M19.75 12.7744L4.75 12.7744"
                        stroke={!transactions?.previous ? "#CCCCCC" : "#212121"}
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M13.7002 18.799L19.7502 12.775L13.7002 6.75"
                        stroke={!transactions?.previous ? "#CCCCCC" : "#212121"}
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                    Prev
                  </button>
                  &nbsp; &nbsp; &nbsp;
                  <button
                    onClick={() => {
                      if (!transactions?.next) {
                        console.log("end");
                      } else {
                        const next = async () => {
                          try {
                            const data = await getTransactions(
                              `?page=${
                                currentPageNo + 1
                              }&search=${searchInput}${
                                checkedAmount
                                  ? `&amountFrom=${amountFrom}&amountTo=${amountTo}`
                                  : ""
                              }${
                                checkedRequestTime
                                  ? `&requestDateFrom=${requestTimeFrom}&requestDateTo=${requestTimeTo}`
                                  : ""
                              }${
                                checkedResponseTime
                                  ? `&responseDateFrom=${responseFrom}&responseDateTo=${responseTo}`
                                  : ""
                              }${
                                checkedRequeryCount
                                  ? `&requeryCountFrom=${requeryCountFrom}&requeryCountTo=${requeryCountTo}`
                                  : ""
                              }${
                                checkedStatusCode ? `&status=${statusCode}` : ""
                              }${
                                checkedRequestType
                                  ? `&status=${requestType}`
                                  : ""
                              }${
                                checkedSourceBank
                                  ? `&sourceBank=${sourceBank}`
                                  : ""
                              }${
                                checkedDestBank ? `&destBank=${destBank}` : ""
                              }${checkedRoute ? `&status=${route}` : ""}`
                            );
                            setCurrentPage((current) => current + 1);
                            setStart((current) => current + 50);
                            setEnd((current) => current + 50);
                            console.log(data);
                          } catch (e) {
                            console.log(e);
                          }
                        };

                        next();
                      }
                    }}
                    style={{
                      backgroundColor: !transactions?.next ? "#fff" : "#F5F5F5",
                      border: "1px solid #E0E0E0",
                      borderRadius: "6px",
                      color: !transactions?.next ? "#CCCCCC" : "#000",
                      cursor: !transactions?.next ? "default" : "pointer",
                      padding: "10px",
                      display: "flex",
                      alignItems: "center",
                      fontSize: "16px",
                    }}
                  >
                    Next
                    <svg
                      style={{
                        marginLeft: "10px",
                      }}
                      width="24"
                      height="25"
                      viewBox="0 0 24 25"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M19.75 12.7744L4.75 12.7744"
                        stroke={!transactions?.next ? "#CCCCCC" : "#212121"}
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M13.7002 18.799L19.7502 12.775L13.7002 6.75"
                        stroke={!transactions?.next ? "#CCCCCC" : "#212121"}
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </button>
                </div>
              </TablePagination>
            </Table>
            {transactModal && (
              <AppModal
                closeModal={() => {
                  setTransactModal(false);
                }}
                maxWidth="1500px"
              >
                <div
                  style={{
                    display: "grid",
                    gap: "20px",
                    gridTemplateColumns: "1fr 1fr 1fr",
                  }}
                >
                  <div style={{ width: "100%" }}>
                    <FormInput
                      defaultValue={transactionDetail?.institution}
                      label="Institution"
                      padding="11px 6px"
                      labelColor="#14A2FD"
                      bottom="0px"
                      disabled={true}
                    />
                  </div>
                  <div style={{ width: "100%" }}>
                    <FormInput
                      defaultValue={transactionDetail?.txid}
                      padding="11px 6px"
                      bottom="0px"
                      labelColor="#14A2FD"
                      label="TXID"
                      disabled={true}
                    />
                  </div>
                  <div style={{ width: "100%" }}>
                    <FormInput
                      defaultValue={transactionDetail?.route}
                      padding="11px 6px"
                      labelColor="#14A2FD"
                      bottom="0px"
                      label="Route"
                      disabled={true}
                    />
                  </div>
                  <div style={{ width: "100%" }}>
                    <FormInput
                      defaultValue={transactionDetail?.sourcebank}
                      labelColor="#14A2FD"
                      padding="11px 6px"
                      bottom="0px"
                      label="Source Bank"
                      disabled={true}
                    />
                  </div>
                  <div style={{ width: "100%" }}>
                    <FormInput
                      defaultValue={transactionDetail?.destbank}
                      padding="11px 6px"
                      bottom="0px"
                      labelColor="#14A2FD"
                      label="Destination Bank"
                      disabled={true}
                    />
                  </div>
                  <div style={{ width: "100%" }}>
                    <FormInput
                      defaultValue={transactionDetail?.routebin}
                      labelColor="#14A2FD"
                      padding="11px 6px"
                      bottom="0px"
                      label="Route Bin"
                      disabled={true}
                    />
                  </div>
                  <div style={{ width: "100%" }}>
                    <FormInput
                      defaultValue={transactionDetail?.accountno}
                      padding="11px 6px"
                      labelColor="#14A2FD"
                      bottom="0px"
                      label="Account Number"
                      disabled={true}
                    />
                  </div>
                  <div style={{ width: "100%" }}>
                    <FormInput
                      defaultValue={transactionDetail?.amount}
                      labelColor="#14A2FD"
                      padding="11px 6px"
                      bottom="0px"
                      label="Amount"
                      disabled={true}
                    />
                  </div>
                  <div style={{ width: "100%" }}>
                    <FormInput
                      defaultValue={transactionDetail?.responsetime}
                      padding="11px 6px"
                      label="Response Time"
                      labelColor="#14A2FD"
                      bottom="0px"
                      disabled={true}
                    />
                  </div>

                  <div style={{ width: "100%" }}>
                    <FormInput
                      defaultValue={transactionDetail?.remark}
                      labelColor="#14A2FD"
                      padding="11px 6px"
                      bottom="0px"
                      label="Remark"
                      disabled={true}
                    />
                  </div>
                  <div style={{ width: "100%" }}>
                    <FormInput
                      defaultValue={transactionDetail?.responseid}
                      padding="11px 6px"
                      labelColor="#14A2FD"
                      label="Response ID"
                      bottom="0px"
                      disabled={true}
                    />
                  </div>
                  <div style={{ width: "100%" }}>
                    <FormInput
                      defaultValue={transactionDetail?.statusmessage}
                      labelColor="#14A2FD"
                      padding="11px 6px"
                      bottom="0px"
                      label="Status Message"
                      disabled={true}
                    />
                  </div>
                  <div style={{ width: "100%" }}>
                    <FormInput
                      defaultValue={transactionDetail?.statuscode}
                      padding="11px 6px"
                      label="Status Code"
                      labelColor="#14A2FD"
                      bottom="0px"
                      disabled={true}
                    />
                  </div>

                  <div style={{ width: "100%" }}>
                    <FormInput
                      defaultValue={transactionDetail?.beneficiary}
                      padding="11px 6px"
                      labelColor="#14A2FD"
                      label="Beneficiary"
                      bottom="0px"
                      disabled={true}
                    />
                  </div>
                  <div style={{ width: "100%" }}>
                    <FormInput
                      defaultValue={transactionDetail?.sender}
                      padding="11px 6px"
                      labelColor="#14A2FD"
                      bottom="0px"
                      label="Sender"
                      disabled={true}
                    />
                  </div>
                  <div style={{ width: "100%" }}>
                    <FormInput
                      defaultValue={transactionDetail?.rrn}
                      padding="11px 6px"
                      label="RRN"
                      labelColor="#14A2FD"
                      bottom="0px"
                      disabled={true}
                    />
                  </div>
                  <div style={{ width: "100%" }}>
                    <FormInput
                      defaultValue={transactionDetail?.debitaccount}
                      padding="11px 6px"
                      bottom="0px"
                      labelColor="#14A2FD"
                      label="Debit Account"
                      disabled={true}
                    />
                  </div>
                  <div style={{ width: "100%" }}>
                    <FormInput
                      defaultValue={transactionDetail?.approved}
                      padding="11px 6px"
                      labelColor="#14A2FD"
                      label="Approved"
                      bottom="0px"
                      disabled={true}
                    />
                  </div>
                  <div style={{ width: "100%" }}>
                    <FormInput
                      defaultValue={transactionDetail?.reversible}
                      padding="11px 6px"
                      bottom="0px"
                      labelColor="#14A2FD"
                      label="Reversible"
                      disabled={true}
                    />
                  </div>
                  <div style={{ width: "100%" }}>
                    <FormInput
                      defaultValue={transactionDetail?.requesttype}
                      padding="11px 6px"
                      labelColor="#14A2FD"
                      label="Request Type"
                      bottom="0px"
                      disabled={true}
                    />
                  </div>
                  <div style={{ width: "100%" }}>
                    <FormInput
                      defaultValue={transactionDetail?.client}
                      label="Client"
                      bottom="0px"
                      labelColor="#14A2FD"
                      padding="11px 6px"
                      disabled={true}
                    />
                  </div>
                  <div style={{ width: "100%" }}>
                    <FormInput
                      defaultValue={transactionDetail?.batchid}
                      padding="11px 6px"
                      bottom="0px"
                      labelColor="#14A2FD"
                      label="Batch ID"
                      disabled={true}
                    />
                  </div>
                  <div style={{ width: "100%" }}>
                    <FormInput
                      defaultValue={transactionDetail?.requestid}
                      bottom="0px"
                      labelColor="#14A2FD"
                      label="Request ID"
                      padding="11px 6px"
                      disabled={true}
                    />
                  </div>
                  <div style={{ width: "100%" }}>
                    <FormInput
                      defaultValue={transactionDetail?.requesttime}
                      padding="11px 6px"
                      bottom="0px"
                      labelColor="#14A2FD"
                      label="Request Time"
                      disabled={true}
                    />
                  </div>
                  <div style={{ width: "100%" }}>
                    <FormInput
                      defaultValue={transactionDetail?.direction}
                      label="Direction"
                      bottom="0px"
                      padding="11px 6px"
                      labelColor="#14A2FD"
                      disabled={true}
                    />
                  </div>
                </div>
              </AppModal>
            )}
            {filter && (
              <ViewAdminBody
                onClick={() => {
                  setFilter(false);
                  setCheckedAmount(false);
                  setCheckedRequeryCount(false);
                  setCheckedRequestTime(false);
                  setCheckedRequestType(false);
                  setCheckedResponseTime(false);
                  setCheckedRoute(false);
                  setCheckedStatusCode(false);

                  setAmountFrom("");
                  setAmountTo("");

                  setRequeryCountFrom("");
                  setRequeryCountTo("");

                  setRequestTimeFrom("");
                  setRequestTimeTo("");

                  setRequeryCountFrom("");
                  setRequeryCountTo("");

                  setStatusCode("");
                  setRoute("");
                  setRequestType("");
                }}
              >
                <ViewAdmin
                  onClick={(e) => {
                    e.stopPropagation();
                  }}
                >
                  <svg
                    onClick={() => {
                      setFilter(false);
                      setCheckedAmount(false);
                      setCheckedRequeryCount(false);
                      setCheckedRequestTime(false);
                      setCheckedRequestType(false);
                      setCheckedResponseTime(false);
                      setCheckedRoute(false);
                      setCheckedStatusCode(false);

                      setAmountFrom("");
                      setAmountTo("");

                      setRequeryCountFrom("");
                      setRequeryCountTo("");

                      setRequestTimeFrom("");
                      setRequestTimeTo("");

                      setRequeryCountFrom("");
                      setRequeryCountTo("");

                      setStatusCode("");
                      setRoute("");
                      setRequestType("");
                    }}
                    style={{
                      position: "absolute",
                      top: "20px",
                      right: "20px",
                      cursor: "pointer",
                    }}
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect width="24" height="24" rx="2.66667" fill="#F4F6FA" />
                    <path
                      d="M15.3337 8.6665L8.66699 15.3332M8.66699 8.6665L15.3337 15.3332"
                      stroke="#007BFF"
                      stroke-width="1.11111"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>

                  <div className="title" style={{ padding: "20px 0" }}>
                    Filter By
                  </div>
                  <div className="filter_body">
                    <div className="section">
                      <img
                        onClick={() => {
                          setCheckedAmount(!checkedAmount);
                        }}
                        src={checkedAmount ? checka : checkb}
                        alt=""
                        srcset=""
                      />
                      <div>
                        <FormInput
                          padding="13px 8px"
                          width="99.5%"
                          label="Amount"
                          type="number"
                          placeholder="From"
                          disabled={!checkedAmount}
                          onChange={(e) => {
                            setAmountFrom(e.target.value);
                          }}
                        />
                        <FormInput
                          padding="13px 8px"
                          width="99.5%"
                          type="number"
                          placeholder="To"
                          disabled={!checkedAmount}
                          onChange={(e) => {
                            setAmountTo(e.target.value);
                          }}
                        />
                      </div>
                    </div>
                    <div className="section">
                      <div>
                        <div className="top">
                          <img
                            onClick={() => {
                              setCheckedRequestTime(!checkedRequestTime);
                            }}
                            src={checkedRequestTime ? checka : checkb}
                            alt=""
                            srcset=""
                          />
                          <div>
                            <label>Request Time</label>
                          </div>
                        </div>

                        <div className="side">
                          <input
                            style={{
                              width: "92.8%",
                              padding: "14px",
                              marginBottom: "20px",
                              borderRadius: "6px",
                              border: "1px solid #5c5c5c",
                            }}
                            label="Request Time"
                            type="date"
                            disabled={!checkedRequestTime}
                            onChange={(e) => {
                              setRequestTimeFrom(e.target.value);
                            }}
                          />
                          <input
                            style={{
                              width: "92.8%",
                              padding: "14px",
                              borderRadius: "6px",
                              border: "1px solid #5c5c5c",
                            }}
                            label="Request Time"
                            type="date"
                            disabled={!checkedRequestTime}
                            onChange={(e) => {
                              setRequestTimeTo(e.target.value);
                            }}
                          />
                        </div>
                      </div>
                    </div>

                    <div className="section">
                      <div>
                        <div className="top">
                          <img
                            onClick={() => {
                              setCheckedResponseTime(!checkedResponseTime);
                            }}
                            src={checkedResponseTime ? checka : checkb}
                            alt=""
                            srcset=""
                          />
                          <div>
                            <label>Response Time</label>
                          </div>
                        </div>

                        <div className="side">
                          <input
                            style={{
                              width: "92.8%",
                              padding: "14px",
                              marginBottom: "20px",
                              borderRadius: "6px",
                              border: "1px solid #5c5c5c",
                            }}
                            label="Request Time"
                            disabled={!checkedResponseTime}
                            type="date"
                            onChange={(e) => {
                              setResponseFrom(e.target.value);
                            }}
                          />
                          <input
                            style={{
                              width: "92.8%",
                              padding: "14px",
                              borderRadius: "6px",
                              border: "1px solid #5c5c5c",
                            }}
                            label="Request Time"
                            disabled={!checkedResponseTime}
                            type="date"
                            onChange={(e) => {
                              setResponseTo(e.target.value);
                            }}
                          />
                        </div>
                      </div>
                    </div>

                    <div className="section">
                      <img
                        onClick={() => {
                          setCheckedRequeryCount(!checkedRequeryCount);
                        }}
                        src={checkedRequeryCount ? checka : checkb}
                        alt=""
                        srcset=""
                      />
                      <div>
                        <FormInput
                          label=" Requery Count"
                          type="number"
                          width="99.5%"
                          padding="13px 8px"
                          placeholder="From"
                          disabled={!checkedRequeryCount}
                          onChange={(e) => {
                            setRequeryCountFrom(e.target.value);
                          }}
                        />
                        <FormInput
                          width="99.5%"
                          type="number"
                          padding="13px 8px"
                          placeholder="To"
                          disabled={!checkedRequeryCount}
                          onChange={(e) => {
                            setRequeryCountTo(e.target.value);
                          }}
                        />
                      </div>
                    </div>
                    <div className="section">
                      <img
                        onClick={() => {
                          setCheckedStatusCode(!checkedStatusCode);
                        }}
                        src={checkedStatusCode ? checka : checkb}
                        alt=""
                        srcset=""
                      />
                      <div>
                        <FormSelect
                          padding="13px 8px"
                          width="99.5%"
                          placeholder="Status Code"
                          label="Status Code"
                          disabled={!checkedStatusCode}
                          onChange={(e) => {
                            setStatusCode(e.target.value);
                          }}
                          options={[
                            { value: "00", label: "00" },
                            { value: "03", label: "03" },
                            { value: "05", label: "05" },
                            { value: "null", label: "Null" },
                            { value: "blank", label: "Blank" },
                          ]}
                          optionLabel="label"
                          optionValue="value"
                        />
                      </div>
                    </div>
                    <div className="section">
                      <img
                        onClick={() => {
                          setCheckedRequestType(!checkedRequestType);
                        }}
                        src={checkedRequestType ? checka : checkb}
                        alt=""
                        srcset=""
                      />
                      <div>
                        <FormSelect
                          padding="13px 8px"
                          placeholder="Request Type"
                          width="99.5%"
                          label="Request Type"
                          disabled={!checkedRequestType}
                          options={[
                            { value: "debit", label: "Credit" },
                            { value: "credit", label: "Debit" },
                          ]}
                          optionLabel="label"
                          optionValue="value"
                          onChange={(e) => {
                            setRequestType(e.target.value);
                          }}
                        />
                      </div>
                    </div>
                    <div className="section">
                      <img
                        onClick={() => {
                          setCheckedRoute(!checkedRoute);
                        }}
                        src={checkedRoute ? checka : checkb}
                        alt=""
                        srcset=""
                      />
                      <div>
                        <FormSelect
                          padding="13px 8px"
                          placeholder="Route"
                          width="99.5%"
                          label="Route"
                          disabled={!checkedRoute}
                          options={[
                            { value: "direct", label: "Direct" },
                            { value: "nip", label: "NIP" },
                          ]}
                          onChange={(e) => {
                            setRoute(e.target.value);
                          }}
                        />
                      </div>
                    </div>

                    <div className="section">
                      <img
                        onClick={() => {
                          setCheckedSourceBank(!checkedSourceBank);
                        }}
                        src={checkedSourceBank ? checka : checkb}
                        alt=""
                        srcset=""
                      />
                      <div>
                        <FormInput
                          label=" Source Bank"
                          type="text"
                          width="99.5%"
                          padding="13px 8px"
                          placeholder="From"
                          disabled={!checkedSourceBank}
                          onChange={(e) => {
                            setSourceBank(e.target.value);
                          }}
                        />
                      </div>
                    </div>

                    <div className="section">
                      <img
                        onClick={() => {
                          setCheckedDestBank(!checkedDestBank);
                        }}
                        src={checkedDestBank ? checka : checkb}
                        alt=""
                        srcset=""
                      />
                      <div>
                        <FormInput
                          label=" Destination Bank"
                          type="text"
                          width="99.5%"
                          padding="13px 8px"
                          placeholder="From"
                          disabled={!checkedDestBank}
                          onChange={(e) => {
                            setDestBank(e.target.value);
                          }}
                        />
                      </div>
                    </div>
                  </div>

                  <div style={{ paddingBottom: "20px" }}>
                    <AppButton
                      onClick={() => {
                        if (
                          (amountFrom && amountTo) ||
                          (requestTimeFrom && requestTimeTo) ||
                          (responseFrom && responseTo) ||
                          (requeryCountFrom && requeryCountTo) ||
                          statusCode ||
                          requestType ||
                          route ||
                          sourceBank ||
                          destBank
                        ) {
                          getTransactions(
                            `?page=${currentPageNo}${
                              checkedAmount
                                ? `&amountFrom=${amountFrom}&amountTo=${amountTo}`
                                : ""
                            }${
                              checkedRequestTime
                                ? `&requestDateFrom=${requestTimeFrom}&requestDateTo=${requestTimeTo}`
                                : ""
                            }${
                              checkedResponseTime
                                ? `&responseDateFrom=${responseFrom}&responseDateTo=${responseTo}`
                                : ""
                            }${
                              checkedRequeryCount
                                ? `&requeryCountFrom=${requeryCountFrom}&requeryCountTo=${requeryCountTo}`
                                : ""
                            }${
                              checkedStatusCode ? `&status=${statusCode}` : ""
                            }${
                              checkedRequestType ? `&status=${requestType}` : ""
                            }${
                              checkedSourceBank
                                ? `&sourceBank=${sourceBank}`
                                : ""
                            }${checkedDestBank ? `&destBank=${destBank}` : ""}${
                              checkedRoute ? `&status=${route}` : ""
                            }`
                          );
                        } else {
                          toast.error("fill required field(s)");
                        }
                      }}
                      loading={loading}
                      placeholder="
                  Apply Filter(s)
                  "
                    ></AppButton>
                    &nbsp;
                    <AppButton
                      onClick={() => {
                        setFilter(false);
                        setCheckedAmount(false);
                        setCheckedRequeryCount(false);
                        setCheckedRequestTime(false);
                        setCheckedRequestType(false);
                        setCheckedResponseTime(false);
                        setCheckedRoute(false);
                        setCheckedStatusCode(false);

                        setAmountFrom("");
                        setAmountTo("");

                        setRequeryCountFrom("");
                        setRequeryCountTo("");

                        setRequestTimeFrom("");
                        setRequestTimeTo("");

                        setRequeryCountFrom("");
                        setRequeryCountTo("");

                        setStatusCode("");
                        setRoute("");
                        setRequestType("");
                      }}
                      placeholder="
                  Cancel"
                      outline
                    ></AppButton>
                  </div>
                </ViewAdmin>
              </ViewAdminBody>
            )}
          </DashboardLayout>
        </>
      )}
      {userData?.userDetail?.institution?.code && (
        <DashboardLayout>
          <InstitutionTransactions
            id={userData?.userDetail?.institution?.code}
          />
        </DashboardLayout>
      )}
    </>
  );
}

const FilterO = styled.div`
  border: 1px solid #e1e1e1;
  border-radius: 10px;
  display: flex;
  align-items: center;
  margin-right: 10px;
  color: #313a4e;
  width: 250px;
  font-size: 14px;
  position: relative;
  cursor: pointer;

  .title {
    padding: 15px;
    width: 80%;
    border-right: 1px solid #e1e1e1;
  }
`;

const Button = styled.div`
  width: fit-content;
  background-color: #009bff;
  border: none;
  color: white;
  border-radius: 8px;
  padding: 15px;
  font-size: 8px 15px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-left: auto;
  font-size: 14px;

  img {
    margin-right: 10px;
    width: 18px;
  }
`;
const Table = styled.div`
  background-color: white;
  border-radius: 10px;
`;

const TableHead = styled.div`
  padding: 0 30px;

  .table_tab {
    display: flex;
    align-items: center;
    margin: 20px 0;
  }

  .table_head {
    padding: 30px 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;

    .table_head_inner {
      width: 100%;
      display: flex;
      align-items: center;
      margin-left: 20px;
      justify-content: space-between;
    }
  }

  .title_a {
    font-size: 18px;
    color: #9291a5;
  }

  .title_b {
    font-size: 26px;
    font-weight: 600;
    margin-top: 10px;
  }
`;

const TableBody = styled.div`
  overflow: hidden;
  overflow-x: scroll;
  overflow-y: scroll;
  height: 72vh;

  &::-webkit-scrollbar {
    width: 10px;
    height: 6px;
    padding: 10px;
  }
  &::-webkit-scrollbar-thumb {
    width: 10px;
    background-color: #019edf;
    border-radius: 30px;
  }
  .table_body_head {
    padding: 20px 30px;
    text-transform: uppercase;
    background: #fafafa;
    color: #14a2fd;
  }
  .grid_attribute {
    display: grid;
    grid-template-columns: repeat(28, 1fr);
    font-size: 12px;
    width: fit-content;
  }
`;

const TableBodyContent = styled.div`
  padding: 10px 0px;
  text-transform: uppercase;
  font-size: 14px;
  cursor: pointer;
  .grid_attribute {
    display: grid;
    grid-template-columns: repeat(28, 1fr);
    width: fit-content;
  }

  .table_body_item {
    padding: 16px 30px;
  }

  .table_body_item:nth-child(even) {
    background: #fafafa;
  }
`;
const TablePagination = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 30px;
  .buttons {
    display: flex;
  }
`;
const ViewAdminBody = styled.div`
  background: #0000005d;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
  height: 100vh;
  overflow: hidden;
  overflow-y: scroll;
  display: grid;
  place-items: center;
  padding: 40px 0;
`;

const ViewAdmin = styled.div`
  background: #fafafa;
  padding: 0px 20px;
  position: fixed;
  bottom: 0;
  right: 50px;
  border-radius: 6px 6px 0px 0px;
  cursor: pointer;
  width: 420px;
  box-shadow: 6px -2px 50px -3px rgba(0, 0, 0, 0.319);
  -webkit-box-shadow: 6px -2px 50px -3px rgba(0, 0, 0, 0.319);
  -moz-box-shadow: 6px -2px 50px -3px rgba(0, 0, 0, 0.319);
  cursor: default;

  cursor: default;
  z-index: 3000;

  .filter_body {
    overflow-y: hidden;
    overflow-y: scroll;
    height: 50vh;

    &::-webkit-scrollbar {
      width: 0;
    }
  }

  div:nth-child(1) {
    border-right: none;
  }
  .title {
    border-bottom: 1px solid #e9e9e9;
    width: 100%;
    font-size: 20px;
    margin-bottom: 20px;
  }

  .section {
    margin-bottom: 20px;
    width: 100%;
    .side {
      width: 100%;
    }
    .top {
      margin-bottom: 10px;
    }
    label {
      font-size: 16px;
      font-weight: 500;
    }
  }
`;
